// Returns false for falsey values & whitespace, true otherwise.
const isFilledIn = value => {
  if (!value) return false;
  if (value.toString().match(/^\s*$/)) return false;
  return true;
};

export default isFilledIn;
